import { APIService } from "../../../../../../../../network/api/APIService";

export const PaymentMethodsData = async () => {
    const config = {
        endpoint: "/affiliate/payout/payment-methods/",
        method: "GET",
    };

    return await APIService(config);
};
